export default [{
	path: "/activity",
	name: "_activity",
	component: () => import("../views/Activity/index"),
	children: [{
			path: "answer/:aid/:sub_aid?",
			name: "answer",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Activity/Answer/Index.vue"),
			meta: {
				title: "天天答题",
				showloading: false,
				requiresAuth: true,
				keepAlive: false
			}
		},

		{
			path: "luckdraw/:acid?",
			name: "luckdraw",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Activity/LuckDraw/Index.vue"),
			meta: {
				title: "幸运抽奖",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "signin/:id?",
			name: "signin",
			component: () => import( /* webpackChunkName: "Orient" */ "../views/Activity/Orient/Index.vue"),
			meta: {
				title: "任务",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "signindetail/:id?",
			name: "signinDetail",
			component: () => import( /* webpackChunkName: "Orient" */ "../views/Activity/Orient/Detail.vue"),
			meta: {
				title: "任务详情",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "steps/:activity_id?",
			name: "stepsDetail",
			component: () => import( /* webpackChunkName: "Orient" */ "../views/Activity/Steps/Detail.vue"),
			meta: {
				title: "健步走",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "stepsx/:activity_id?",
			name: "xstepsDetail",
			component: () => import( /* webpackChunkName: "Orient" */ "../views/Activity/StepsX/Detail.vue"),
			meta: {
				title: "徐汇健步走",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "stepsp/:activity_id?",
			name: "pstepsDetail",
			component: () => import( /* webpackChunkName: "Orient" */ "../views/Activity/StepsP/Detail.vue"),
			meta: {
				title: "浦东健步走",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "rankList",
			name: "rank",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Activity/Rank/rankList.vue"),
			meta: {
				title: "签位排位",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "grouprank/:acid",
			name: "groupList",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Activity/Grouprank/Index.vue"),
			meta: {
				title: "团队排行",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "qrcoderank/:acid",
			name: "qrcodeList",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Activity/Qrrank/Index.vue"),
			meta: {
				title: "团队排行",
				showloading: true,
				requiresAuth: true
			}
		},
		{
			path: "grades",
			name: "grades",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Activity/Rank/grade.vue"),
			meta: {
				title: "打分",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "dashboard",
			name: "dashboard",
			component: () => import( /* webpackChunkName: "activity" */ "../views/databoard"),
			meta: {
				title: "大屏",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "setdashboard",
			name: "setdashboard",
			component: () => import( /* webpackChunkName: "activity" */ "../views/setdashboard"),
			meta: {
				title: "大屏设置",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "score",
			name: "score",
			component: () => import( /* webpackChunkName: "activity" */ "../views/score"),
			meta: {
				title: "打分",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "setting",
			name: "setting",
			component: () => import( /* webpackChunkName: "activity" */ "../views/setting"),
			meta: {
				title: "设置",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "game",
			name: "game",
			component: () => import( /* webpackChunkName: "activity" */ "../views/game"),
			meta: {
				title: "网球",
				showloading: true,
				requiresAuth: false
			}
		},
		
		{
			path: "tennisdashboard",
			name: "tennisdashboard",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Tennis/dashboard"),
			meta: {
				title: "五星网球大屏",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "tennisreferee",
			name: "tennisreferee",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Tennis/referee"),
			meta: {
				title: "五星网球裁判打分",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "tennissetting",
			name: "tennissetting",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Tennis/setting"),
			meta: {
				title: "五星网球设置",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "tennissubtitle",
			name: "tennissubtitle",
			component: () => import( /* webpackChunkName: "activity" */ "../views/Tennis/subtitle"),
			meta: {
				title: "五星网球字幕",
				showloading: true,
				requiresAuth: false
			}
		},
		{
			path: "scan/:acid/:sub_aid?",
			name: "scan",
			component: () => import(/* webpackChunkName: "home" */"../views/Activity/Scan/index.vue"),
			meta: {
				requiresAuth: true,
				showloading: false,
				title:" "
			}
		},
		{
			path: "scandetail/:acid/:sub_aid?",
			name: "scanDetail",
			component: () => import(/* webpackChunkName: "home" */"../views/Activity/ScanDetail/index.vue"),
			meta: {
				requiresAuth: true,
				showloading: false,
				title:" "
			}
		},
		{
			path: "scancoupon/:acid",
			name: "scanCoupon",
			component: () => import(/* webpackChunkName: "home" */"../views/Activity/Coupon/index.vue"),
			meta: {
				requiresAuth: true,
				showloading: false,
				title:" "
			}
		},


	]
}];
